import { getLang } from 'utils/literals';

/**
 * Literals passed into lead-pop. All user-facing keys resolve through web4 `getLiteral`.
 * @param {(key: string, ...args: unknown[]) => string} getLiteral
 * @param {string} [lang] Web4 language code (`getLang()`).
 */
export function buildLeadPopLiterals(getLiteral, lang = getLang()) {
    void lang;

    return {
        'hud.score': getLiteral('label_leads_game_hud_score'),
        'hud.time': getLiteral('label_leads_game_hud_time'),
        'hud.lives': getLiteral('label_leads_game_hud_lives'),
        'hud.livesAria': getLiteral('label_leads_game_hud_lives_aria'),
        'hud.soundOn': getLiteral('label_leads_game_hud_sound_on'),
        'hud.soundOff': getLiteral('label_leads_game_hud_sound_off'),
        'hud.soundToggle': getLiteral('label_leads_game_hud_sound_toggle'),
        'hud.good': getLiteral('label_leads_game_hud_good'),
        'game.title': getLiteral('label_leads_game_title'),
        'game.subtitle': getLiteral('label_leads_enhancement_progress'),
        'game.intro.title': getLiteral('label_leads_game_intro_title'),
        'game.intro.subtitle': getLiteral('label_leads_game_intro_subtitle'),
        'game.intro.go': getLiteral('label_leads_game_intro_go'),
        'game.paused': getLiteral('label_leads_game_paused'),
        'game.soundHint': getLiteral('label_leads_game_sound_hint'),
        'result.finished': getLiteral('label_leads_enhancement_complete'),
        'result.died': getLiteral('label_leads_game_result_died'),
        'result.skipped': getLiteral('label_leads_game_result_skipped'),
        'result.score': getLiteral('label_leads_game_result_score'),
        'result.goodHits': getLiteral('label_leads_game_result_good_hits'),
        'result.badHits': getLiteral('label_leads_game_result_bad_hits'),
        'result.copy': getLiteral('label_leads_game_result_copy'),
        'result.copying': getLiteral('label_leads_game_result_copying'),
        'result.copiedImage': getLiteral('label_leads_game_result_copied_image'),
        'result.copiedText': getLiteral('label_leads_game_result_copied_text'),
        'result.copyError': getLiteral('label_leads_game_result_copy_error'),
        'result.restart': getLiteral('label_leads_game_result_restart'),
        'result.viewProspectingResults': getLiteral('action_leads_view_enhancement_results'),
        'items.hot': getLiteral('label_leads_game_item_hot'),
        'items.bonusName': getLiteral('label_leads_game_item_bonus_name'),
        'items.bonus': getLiteral('label_leads_game_item_bonus'),
        'activities.phoneCall': getLiteral('label_leads_game_activity_phone_call'),
        'activities.checkIn': getLiteral('label_leads_game_activity_check_in'),
        'activities.videoCheckIn': getLiteral('label_leads_game_activity_video_check_in'),
        'activities.fastCheckIn': getLiteral('label_leads_game_activity_fast_check_in'),
        'activities.email': getLiteral('label_leads_game_activity_email'),
        'activities.videoCall': getLiteral('label_leads_game_activity_video_call'),
        'activities.whatsapp': getLiteral('label_leads_game_activity_whatsapp'),
        'badItems.spam': getLiteral('label_leads_game_bad_spam'),
        'badItems.spam.subtitle': getLiteral('label_leads_game_bad_spam_subtitle'),
        'badItems.urgentMeeting': getLiteral('label_leads_game_bad_urgent_meeting'),
        'badItems.urgentMeeting.subtitle': getLiteral(
            'label_leads_game_bad_urgent_meeting_subtitle',
        ),
        'badItems.ghostClient': getLiteral('label_leads_game_bad_ghost_client'),
        'badItems.ghostClient.subtitle': getLiteral('label_leads_game_bad_ghost_client_subtitle'),
        'badItems.infiniteExcel': getLiteral('label_leads_game_bad_infinite_excel'),
        'badItems.infiniteExcel.subtitle': getLiteral(
            'label_leads_game_bad_infinite_excel_subtitle',
        ),
        'badItems.massCc': getLiteral('label_leads_game_bad_mass_cc'),
        'badItems.massCc.subtitle': getLiteral('label_leads_game_bad_mass_cc_subtitle'),
        'badItems.surpriseMeeting': getLiteral('label_leads_game_bad_surprise_meeting'),
        'badItems.surpriseMeeting.subtitle': getLiteral(
            'label_leads_game_bad_surprise_meeting_subtitle',
        ),
        'badItems.zombieLead': getLiteral('label_leads_game_bad_zombie_lead'),
        'badItems.zombieLead.subtitle': getLiteral('label_leads_game_bad_zombie_lead_subtitle'),
        'badItems.coldCoffee': getLiteral('label_leads_game_bad_cold_coffee'),
        'badItems.coldCoffee.subtitle': getLiteral('label_leads_game_bad_cold_coffee_subtitle'),
        'badItems.duplicate': getLiteral('label_leads_game_bad_duplicate'),
        'badItems.duplicate.subtitle': getLiteral('label_leads_game_bad_duplicate_subtitle'),
    };
}
